import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "./Leaderboard.css";

const Leaderboard = () => {
  const { gameId } = useParams(); // gameId can be undefined
  const [leaderboard, setLeaderboard] = useState([]);
  const [gameTitle, setGameTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchLeaderboard = async () => {
      setLoading(true);
      setError("");

      if (!gameId) {
        setError("No game selected. Please play a game to see its leaderboard.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`http://localhost:5001/api/games/${gameId}/leaderboard`);

        if (!response.ok) throw new Error("Failed to fetch leaderboard");

        const data = await response.json();

        if (data?.length > 0) {
          setLeaderboard(data);
          setGameTitle(data[0]?.game?.title || "Unknown Game");
        } else {
          setError("No leaderboard data available.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [gameId]);

  return (
    <div className="leaderboard-container">
      <header>
        <h1>🏆 Leaderboard</h1>
        {gameTitle && <h2>Game: {gameTitle}</h2>}
      </header>

      <main>
        {loading ? (
          <p className="loading">Loading leaderboard...</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : (
          <ul>
            {leaderboard.map((entry, index) => (
              <li key={entry._id}>
                <span className="rank">#{index + 1}</span>
                <span className="username">{entry.user.username}</span>
                <span className="score">{entry.score} pts</span>
              </li>
            ))}
          </ul>
        )}
      </main>

      <footer>
        <Link to="/" className="home-btn">⬅ Back to Home</Link>
        <p>© 2025 Unfamiliar Gaming. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Leaderboard;